import React from 'react';
import DetailViewItem from './DetailViewItem';
import GridViewItem from './GridViewItem';
import GridViewItemSmall from './GridViewItemSmall';
import { Product as TProduct, ProductType } from '~redux/brand/types';

type ProductListViewItemProps = {
  product?: TProduct;
  productTypes?: ProductType[];
  border?: boolean;
  index?: number;
  col?: boolean;
  showBrand?: boolean;
  unAuth?: boolean;
  isLongListView?: boolean;
  hideBadge?: boolean;
  layout?: 'grid' | 'detail';
  preview?: boolean;
  image?: string;
  moveFavoriteList?: boolean;
};

const ProductListViewItem: React.FC<ProductListViewItemProps> = ({
  layout = 'grid',
  product,
  index,
  ...props
}) => {
  if (!product) {
    return <GridViewItem {...props} />;
  }

  if (!product.brand) {
    return null;
  }

  if (layout === 'detail') {
    return <DetailViewItem product={product} {...props} index={index!} />;
  }

  return <GridViewItemSmall product={product} index={index!} {...props} />;
};

export default ProductListViewItem;
